// src/layout/MainLayout.tsx
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar';
import Topbar from './header';
import Footer from './footer';


const MainLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true)

  useEffect(() => {
    // Set sidebar open by default for desktop
    const handleResize = () => {
      if (window.innerWidth >= 1194) { // Updated to 1194px to stay open on laptops while closing on iPad Pro
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
          type: "CURRENT_ROUTE",
          route: window.location.pathname,
      });
    }

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Topbar 
        toggle={() => setSidebarOpen(!sidebarOpen)} 
        isOpen={sidebarOpen} 
      />
      <div className="flex flex-1">
        <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
        <main className={`flex-1 flex flex-col overflow-x-hidden overflow-y-auto bg-gray-50 transition-all duration-300 ease-in-out relative
          ${sidebarOpen ? 'lg:ml-64' : 'ml-0'} mt-16`}>
          {/* Background Overlay for main content only */}
          <div 
            className={`absolute inset-0 bg-black/50 transition-opacity duration-300 lg:hidden z-[8] ${
              sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
            }`}
            onClick={() => setSidebarOpen(false)}
            data-testid="overlay"
          />
          <div className="flex-1">
            <Outlet/>
          </div>
          <Footer/>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;